<template>
  <div class="mr-54px d-fx fxd-c">
    <span class="f-13px lh-16px c-999999" style="letter-spacing: 0.32px">{{title | upperCase}}</span>
    <span class="f-24px fw-300 lh-26px c-222222 mt-18px">{{count}}</span>
  </div>
</template>

<script>
export default {
  name: 'DataCountC',
  extends: {},
  props: {
    title: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      required: true
    }
  },
  data(){
    return{};
  },
  filters: {
    upperCase (value) {
      return (!value) ? '' : value.toUpperCase()
    }
  },
  components: {},
  computed: {},
  watch: {},
  methods: {},
  beforeCreate(){},
  mounted(){}
}
</script>
